import React, { useState } from 'react';
import ProfileForm from './ProfileForm';
import useUserProfile from '../../hooks/useUserProfile';
import { updateUserProfile } from '../../services/userProfileService';

const DadosPessoais = () => {
  const {
    nome,
    email,
    cpf,
    photoURL,
    titulo,
    setNome,
    setEmail,
    setCpf,
    setTitulo,
    setShowProfessionalTab,
    setPhotoURL, // Importante para atualizar a imagem no perfil
  } = useUserProfile();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validação do tipo e tamanho do arquivo
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        setMessage(
          'Formato de arquivo inválido. Por favor, selecione um arquivo JPG ou PNG.'
        );
        return;
      }

      if (file.size > 1048576) {
        setMessage('O arquivo é muito grande. O tamanho máximo é 1MB.');
        return;
      }

      setSelectedFile(file);
    }
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const userData = { nome, email, cpf, photoURL, titulo };
      const updatedPhotoURL = await updateUserProfile(userData, selectedFile);

      if (updatedPhotoURL) {
        setPhotoURL(updatedPhotoURL); // Atualiza a URL da foto no perfil
      }

      setMessage('Perfil atualizado com sucesso!');
    } catch (error) {
      setMessage('Erro ao atualizar perfil: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProfileForm
      nome={nome}
      email={email}
      cpf={cpf}
      titulo={titulo}
      photoURL={photoURL}
      loading={loading}
      message={message}
      setNome={setNome}
      setEmail={setEmail}
      setCpf={setCpf}
      setTitulo={setTitulo}
      setShowProfessionalTab={setShowProfessionalTab}
      handleFileChange={handleFileChange}
      handleUpdateProfile={handleUpdateProfile}
    />
  );
};

export default DadosPessoais;
